/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const publicHolidayResponseSchema = z.object({
  counties: z.array(z.string()).nullish(),
  countryCode: z.string(),
  date: z.iso.date(),
  global: z.boolean(),
  launchYear: z.int().nullish(),
  localName: z.string(),
  name: z.string(),
  types: z.array(z.string()).nullish(),
});
